import { render, staticRenderFns } from "./ConfirmBtn.vue?vue&type=template&id=12b8ef22&scoped=true&"
import script from "./ConfirmBtn.vue?vue&type=script&lang=js&"
export * from "./ConfirmBtn.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBtn.vue?vue&type=style&index=0&id=12b8ef22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8ef22",
  null
  
)

export default component.exports